import axios from 'axios'
import Vue from 'vue'
import store from "@/store"
import ToastPlugin from 'vux/src/plugins/toast/index.js'

import router from '../router/index'
Vue.use(ToastPlugin)
/* eslint-disable no-new */

let vm = new Vue()
const service = axios.create({
baseURL: '', // url = base url + request url

timeout: 50000, // request timeout
headers: {
'Cache-Control': 'no-cache',
}
})

service.defaults.headers.post["Content-Type"] = "application/json";

service.interceptors.request.use(config => {


let token = store.state.user.info.Authorization;

if(token){
config.headers["Authorization"] = `${token}`;
}else{
config.headers["Authorization"] = "Basic aW90YmQtZHZlOmlvdGJkLWR2ZQ==";
}
console.log('config---------'+config.url);

return config
},
error => {

console.log(error) 
return Promise.reject(error)
}
)

service.interceptors.response.use(
/**
* If you want to get http information such as headers or status
* Please return  response => response
*/

/**
* Determine the request status by custom code
* Here is just an example
* You can also judge the status by HTTP Status Code
*/
async response => {
const res = response.data


if(res.Code == "0005"){//当事人token失效,重新登录20230828
console.log('0005---------'+response.config);
console.log('userinfo-------------------------------',store.state.user);
store.dispatch('UserInfo','');
console.log('delete userinfo-------------------------------',store.state.user);
router.push({//跳转到登录页面
path:'login'

});
return;

}else if(res.Code == "0006"){//法官token失效,重新登录20230828
console.log('0006---------'+response.config);
var url = window.location.href;
url = new URL(url);
var searchParams = url.searchParams;
var types=searchParams.get("type"); 
var path=router.app._route.path;
console.log(router.app._route.path);
if(path&&!types){
var uurlObj={'/huifufankui':'0','/anjianliuyan_faguan':'1','/faguanlist_faguan':'2','/yongjun':'3','/daiwoshenhe':'4','/shenherencaozuo':'5','/sifazhuxing':'6','/faceToFace_faguan':'7','/dianduidian':'8'};
types=uurlObj[path];

}



store.dispatch('deleteUserinfo');
router.push({
path:'/judgeAuthorize',
query:{type:types}
});

}else if (res.Code !== "0000") {






Promise.reject(new Error(res.message || 'Error')).catch((e) => {})
return res
} else {
return res
}
},
error => {
console.log('err' + error) 





return Promise.reject(error)
}
)

export default service



// WEBPACK FOOTER //
// ./src/api/base.js